import { useLoaderData } from "react-router-dom";
import { Link } from "react-router-dom";
import { checkExpiry, formatDate, getUserId } from "../services/helpers";
import {  useEffect, useState } from "react";
import { TextField } from "../components/TextField";
import mixpanel from "../services/mixpanel";


export default function  SubscriptionHistoryPage(){
	const loaderData = useLoaderData();
	const history = loaderData.history.subscriptions;
	console.log("history",history);
	const [_filterStartDate,_setFilterStartDate] = useState(null);
	const [_filterEndDate,_setFilterEndDate] = useState(null);
	const [_showDateFilterPop,_setShowDateFilterPopup] = useState(false);
	const [searchFilter,setSearchFilter] = useState('');

	useEffect(()=>{
		mixpanel.identify(getUserId());
	},[]);





	return (<main>
		<h1>Membership Subscription History</h1>

		<div id="page-actions" className="row">

			<TextField
			label="Filter by name or Member ID"
				hint="Customer Name or Membership ID"
				value={searchFilter}
				onChange={(value)=>{setSearchFilter(value.target.value);}}
			/>

						<div className="popup-container">
							<button className="link" onClick={()=> _setShowDateFilterPopup(prev=>!prev)}> Filter By Date</button>
							{_showDateFilterPop && <span className="popup">
								<TextField
									label="Start Date"
									value={_filterStartDate ?? ""}
									type="date"
									onChange={(e)=> _setFilterStartDate(e.target.value)}
								/>
								<TextField
									label="End Date"
									value={_filterEndDate ?? ""}
									type="date"
									onChange={(e)=> _setFilterEndDate(e.target.value)}
								/>
								<div className="row space-between">
									<button className="link red-text" onClick={()=>{
										_setFilterStartDate(null);
										_setFilterEndDate(null);
										_setShowDateFilterPopup(false);
									}}>Reset</button>
									<button className="link" onClick={()=>_setShowDateFilterPopup(false)}>Close</button>
								</div>
							</span>}
						</div>
		</div>
		<table>
			<thead>
						<tr>
							<th>Member Id</th>
							<th>Customer Name</th>
							<th>Plan Name</th>
							<th>Date Subscribed</th>
							<th>Payment Method</th>
							<th>Amount Paid</th>
							<th>Expiry Date</th>
						</tr>
					</thead>
					<tbody>
						{history.filter(subscription =>
							(`${subscription.customer_name}`.toLowerCase().includes(searchFilter.trim().toLowerCase()) || `${subscription.member_id}`.toLowerCase().includes(searchFilter.trim().toLowerCase())) &&
							(!_filterStartDate || new Date(subscription.date_subscribed) >= new Date(_filterStartDate)) &&
							(!_filterEndDate || new Date(subscription.date_subscribed) <= new Date(_filterEndDate))
						).
						map((subscription) => (
							<tr key={subscription.entry_id}>
								<td>{subscription.member_id}</td>
								<td>{subscription.customer_name}</td>
								<td>{subscription.plan_name}</td>
								<td>{formatDate(subscription.date_subscribed,false)}</td>
								<td>{subscription.method_name}</td>
								<td>{subscription.currency} {subscription.amount}</td>
								{/* <td>{subscription.expiry_date}</td> */}
								<td className={`${checkExpiry(subscription.expiry_date) && "red-text"}`}>{formatDate(subscription.expiry_date,false)}</td>
							</tr>
						))}
					</tbody>
		</table>
	</main>)
}